import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', href: '/' },
  { label: '商品分类', href: '/categories' },
  { label: '黄油知识', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
        >
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-cake-2-line text-2xl text-primary-500"></i>
          </div>
          <span className="text-lg font-heading font-semibold">在线黄油</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === item.href
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/categories"
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-cart-2-line text-sm"></i>
            </span>
            立即选购
          </Link>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden flex items-center justify-center w-10 h-10 text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </span>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                  location.pathname === item.href
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/categories"
              className="mt-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-cart-2-line text-sm"></i>
              </span>
              立即选购
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}